<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        stateOptions: [],
        statusOptions: [],
        form: [
          { // 文件状态
            label: '文件状态',
            value: 'state',
            type: 'select',
            placeholder: '请选择文件状态',
          },
          { // 业务名称
            label: '业务名称',
            value: 'bizName',
            type: 'input',
            placeholder: '请输入业务名称',
          },
          { // 批次号码
            label: '批次号码',
            value: 'batchId',
            type: 'input',
            placeholder: '请输入批次号码',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      searchBoxData.type = 2;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'TAB_IMPORT_STATE',
    });
    this.searchBoxData.stateOptions = enumsList[0];
  },
};
</script>

<style lang="scss" scoped>
</style>
